export interface NavItem {
  label: string;
  href: string;
  description?: string;
  icon?: string;
  badge?: string;
}

export const MAIN_NAV_ITEMS: NavItem[] = [
  {
    label: "Fantasy",
    href: "/fantasy",
    description: "Elves, Dragons, Wizards, Demons & Mythical Beasts",
    icon: "✨",
  },
  {
    label: "Real & Cultural",
    href: "/real",
    description: "Historical, Ancient, Celtic, Norse, Asian & Global names",
    icon: "🌍",
  },
  {
    label: "Places & Realms",
    href: "/places",
    description: "Kingdoms, Taverns, Galaxies, Continents & Cities",
    icon: "🏰",
  },
  {
    label: "Pop Culture",
    href: "/pop-culture",
    description: "DnD, Harry Potter, Star Wars, LotR, Anime & Video Games",
    icon: "⚔️",
  },
  {
    label: "Master Directory",
    href: "/directory",
    description: "Complete A-Z index of all naming generators",
    icon: "📜",
  },
];

export const FOOTER_CLUSTERS = [
  {
    title: "Fantasy & Mythical",
    links: [
      { label: "Elf Names", href: "/fantasy/elf-names" },
      { label: "Dragon Names", href: "/fantasy/dragon-names" },
      { label: "Wizard Names", href: "/fantasy/wizard-names" },
      { label: "Demon Names", href: "/fantasy/demon-names" },
      { label: "Angel Names", href: "/fantasy/angel-names" },
      { label: "Vampire Names", href: "/fantasy/vampire-names" },
    ],
  },
  {
    title: "Real & Cultural",
    links: [
      { label: "Kingdom & Realm Names", href: "/places/kingdom-names" },
      { label: "Fantasy City Names", href: "/places/city-names" },
      { label: "Tavern & Inn Names", href: "/places/tavern-names" },
      { label: "Norse & Viking Names", href: "/real/viking-names" },
      { label: "Celtic Names", href: "/real/celtic-names" },
      { label: "Ancient Greek Names", href: "/real/ancient-greek-names" },
    ],
  },
  {
    title: "Pop Culture & RPG",
    links: [
      { label: "D&D Character Names", href: "/pop-culture" },
      { label: "Hogwarts & Wizard Lore", href: "/pop-culture/hp-wizard-names" },
      { label: "Star Wars & Sci-Fi", href: "/pop-culture" },
      { label: "The Witcher Lore", href: "/pop-culture" },
      { label: "Anime Character Names", href: "/fantasy/anime-character-names" },
    ],
  },
  {
    title: "Platform & Guides",
    links: [
      { label: "About Paul Arcane", href: "/about" },
      { label: "Contact & Inquiries", href: "/contact" },
      { label: "D&D 5e Character Names", href: "/best/dnd-character-names" },
      { label: "Fantasy Worldbuilding Hub", href: "/best/fantasy-world-names" },
      { label: "Master A-Z Directory", href: "/directory" },
    ],
  },
];
